import React, {Component} from 'react';
import home from '../home.png';


class Home extends Component {


    render() {
        return(
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-5" style={{justifyContent: "center", alignItems: "center"}}>
                        <img src={home} alt="Oops!" height="100%" width="100%" justifyContent="center" backgroundSize="cover"/>
                    </div>
                    <div className="col-12 col-md-6" style={{justifyContent: "center",padding:"25px", alignItems: "center"}}>
                        <h2 style={{fontFamily:'Menlo'}}><span style={{color: "green", fontWeight: "bolder"}}>&lt;</span> <span style={{color: "black"}}>Hello</span> <span style={{color: "gray"}}>World</span> <span style={{color: "black", fontWeight: "bolder"}}>/</span><span style={{color: "green", fontWeight: "bolder"}}>&gt;</span></h2>
                        <hr style={{height:"1.2px", width:"16%",textAlign:"left",marginLeft:"0",backgroundColor:"green"}}/>
                        <p style={{fontFamily:"Montserrat",fontWeight:"bold", fontSize:"22px"}}>Welcome to this portfolio website. </p>
                        <p>This website is built using ReactJs. To know more visit my github repository...</p>
                        <h4>Want to contribute to this project?</h4>
                        <p>I'll release this section after a stable version is build...</p>
                        <p>Stay connected to know more...</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;